import { baseApi } from 'api'
import { ApiResponse } from 'helpers/types'
import { TerminalItemResponse } from 'schema'

import {
  TDestinationTerminalByCoordinatesRequestData,
  TTerminalByCoordinatesRequestData,
  TTerminalByCoordinatesResponseData
} from '../types'

export const deliveryInfoApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    findTerminalDepartureListByCoordinates: build.mutation<
      ApiResponse<TTerminalByCoordinatesResponseData>,
      TTerminalByCoordinatesRequestData
    >({
      query: ({ latitude, longitude, address, customerId }) => ({
        url: 'terminal/departure-list-by-coordinates',
        method: 'GET',
        params: {
          latitude,
          longitude,
          address,
          customerId: customerId || undefined
        }
      })
    }),
    findTerminalDepartureItemByCoordinates: build.mutation<
      ApiResponse<TerminalItemResponse>,
      TTerminalByCoordinatesRequestData
    >({
      query: ({ latitude, longitude, address, customerId }) => ({
        url: 'terminal/departure-item-by-coordinates',
        method: 'GET',
        params: {
          latitude,
          longitude,
          address,
          customerId: customerId || undefined
        }
      })
    }),
    findTerminalDestinationListByCoordinates: build.mutation<
      ApiResponse<TTerminalByCoordinatesResponseData>,
      TDestinationTerminalByCoordinatesRequestData
    >({
      query: ({ latitude, longitude, address, customerId, departureTerminalId }) => ({
        url: 'terminal/destination-list-by-coordinates',
        method: 'GET',
        params: {
          latitude,
          longitude,
          address,
          customerId: customerId || undefined,
          departureTerminalId: departureTerminalId || undefined
        }
      })
    }),
    findTerminalDestinationItemByCoordinates: build.mutation<
      ApiResponse<TerminalItemResponse>,
      TDestinationTerminalByCoordinatesRequestData
    >({
      query: ({ latitude, longitude, address, customerId, departureTerminalId }) => ({
        url: 'terminal/destination-item-by-coordinates',
        method: 'GET',
        params: {
          latitude,
          longitude,
          address,
          customerId: customerId || undefined,
          departureTerminalId: departureTerminalId || undefined
        }
      })
    })
  }),
  overrideExisting: false
})

export const {
  useFindTerminalDepartureListByCoordinatesMutation,
  useFindTerminalDepartureItemByCoordinatesMutation,
  useFindTerminalDestinationListByCoordinatesMutation,
  useFindTerminalDestinationItemByCoordinatesMutation
} = deliveryInfoApi
